import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { MenuItem, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import * as Yup from "yup";
import CandidateFitIco from "../../../../assets/icons/CandidateFitIco";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input";
import DropDownSelect from "../../../../component/Select";
import SnackBar from "../../../../component/SnackBar";
import { CustomDiv } from "../../../../modules/chat-bot/style";
import { CommonGrid2 } from "../../../../modules/common-components/StyledComponents";
import { CustomizeSpan } from "../../../../modules/jobs/style";
import {
  AutomationGetCall,
  AutomationUpdate,
} from "../../../../redux/action/settings";
import { HandleSkeletion } from "../../../../utils/constants";
import { StageTimeSetting } from "../../style";

export default function Automation() {
  const [automation, setAutomation] = useState({
    normal_deadline: {
      Share: "",
      Scoring: "",
      Activation: "",
      Coversheet: "",
      Submission: "",
      LiveScreen: "",
    },
    high_priority_deadline: {
      Share: "",
      Scoring: "",
      Activation: "",
      Coversheet: "",
      Submission: "",
      LiveScreen: "",
    },
    number_of_coversheet_candidates: "",
    required_score: "",
    share_emails: [],
    loading: true,
  });
  const [button, setButton] = useState({
    condition: true,
    disabled: false,
    saveLoading: false,
    cancelLoading: false,
  });
  const statusOptions = [
    {
      name: "Internal Recruiter",
      value: "internal_recruiter",
    },
    { name: "External Recruiter", value: "external_recruiter" },
    { name: "External vendor", value: "external_vendor" },
  ];
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const validationSchema = Yup.object().shape({
    normal_deadline: Yup.object().shape({
      Share: Yup.string()
        .test(
          "not-zero-time",
          "Share is required",
          (value) => value && value !== "00:00" && value !== "0:00"
        )
        .required("Share is required"),
      Scoring: Yup.string()
        .test(
          "not-zero-time",
          "Scoring is required",
          (value) => value && value !== "00:00" && value !== "0:00"
        )
        .required("Scoring is required"),
      Activation: Yup.string()
        .test(
          "not-zero-time",
          "Activation is required",
          (value) => value && value !== "00:00" && value !== "0:00"
        )
        .required("Activation is required"),
      Coversheet: Yup.string()
        .test(
          "not-zero-time",
          "Coversheet is required",
          (value) => value && value !== "0:00" && value !== "00:00"
        )
        .required("Coversheet is required"),
      Submission: Yup.string()
        .test(
          "not-zero-time",
          "Submission is required",
          (value) => value && value !== "00:00" && value !== "0:00"
        )
        .required("Submission is required"),
      LiveScreen: Yup.string()
        .test(
          "not-zero-time",
          "Live Screen is required",
          (value) => value && value !== "00:00" && value !== "0:00"
        )
        .required("Live Screen is required"),
    }),

    high_priority_deadline: Yup.object().shape({
      Share: Yup.string()
        .test(
          "not-zero-time",
          "Share is required",
          (value) => value && value !== "00:00" && value !== "0:00"
        )
        .required("Share is required"),
      Scoring: Yup.string()
        .test(
          "not-zero-time",
          "Scoring is required",
          (value) => value && value !== "00:00" && value !== "0:00"
        )
        .required("Scoring is required"),
      Activation: Yup.string()
        .test(
          "not-zero-time",
          "Activation is required",
          (value) => value && value !== "00:00" && value !== "0:00"
        )
        .required("Activation is required"),
      Coversheet: Yup.string()
        .test(
          "not-zero-time",
          "Coversheet is required",
          (value) => value && value !== "0:00" && value !== "00:00"
        )
        .required("Coversheet is required"),
      Submission: Yup.string()
        .test(
          "not-zero-time",
          "Submission is required",
          (value) => value && value !== "00:00" && value !== "0:00"
        )
        .required("Submission is required"),
      LiveScreen: Yup.string()
        .test(
          "not-zero-time",
          "Live Screen is required",
          (value) => value && value !== "00:00" && value !== "0:00"
        )
        .required("Live Screen is required"),
    }),
    number_of_coversheet_candidates: Yup.string().required(
      "Number of coversheet candidates is required"
    ),
    required_score: Yup.string().required("Required score is required"),
    share_emails: Yup.array().of(
      Yup.object().shape({
        email: Yup.string()
          .email("Enter a valid email")
          .required("Email is required"),
        type: Yup.string().nullable(),
      })
    ),
  });

  const stageTimeSetting = [
    {
      title: "High Priority Deadlines",
      data: [
        {
          name: "Job Activation",
          titleName: "Activation",
          objectName: "high_priority_deadline",
          description: "Done within",
        },
        {
          name: "Job Sharing",
          titleName: "Share",
          objectName: "high_priority_deadline",
          description: "Done within",
        },
        {
          name: "Resume Scoring",
          titleName: "Scoring",
          objectName: "high_priority_deadline",
          description: "Done within",
        },
        {
          name: "Request Info.",
          titleName: "Coversheet",
          objectName: "high_priority_deadline",
          description: "Done within",
        },
        {
          name: "Coversheet scoring",
          titleName: "LiveScreen",
          objectName: "high_priority_deadline",
          description: "Done within",
        },
        {
          name: "Submission",
          titleName: "Submission",
          objectName: "high_priority_deadline",
          description: "Done within",
        },
      ],
    },
    {
      title: "Low Priority Deadlines",
      data: [
        {
          name: "Job Activation",
          titleName: "Activation",
          objectName: "normal_deadline",
          description: "Done within",
        },
        {
          name: "Job Sharing",
          titleName: "Share",
          objectName: "normal_deadline",
          description: "Done within",
        },
        {
          name: "Resume Scoring",
          titleName: "Scoring",
          objectName: "normal_deadline",
          description: "Done within",
        },
        {
          name: "Request Info.",
          titleName: "Coversheet",
          objectName: "normal_deadline",
          description: "Done within",
        },
        {
          name: "Coversheet scoring",
          titleName: "LiveScreen",
          objectName: "normal_deadline",
          description: "Done within",
        },
        {
          name: "Submission",
          titleName: "Submission",
          objectName: "normal_deadline",
          description: "Done within",
        },
      ],
    },
  ];

  const otherSetting = [
    {
      title: "Other Settings",
      data: [
        {
          name: "Job Activation",
          titleName: "required_score",
          description: "Minimum score required for Job Activation",
          span_info: "(Recommended > 60%)",
        },
        // {
        //   name: "Resume Collection",
        //   objectName: "normal_deadline",
        //   description: "Minimum number of Resumes to be collected",
        //   disabled: true,
        // },
        {
          name: "Cover Sheet Settings",
          titleName: "number_of_coversheet_candidates",
          description: "Request candidate info from the top",
          span_info: "(eg. Top 5)",
        },
        // {
        //   name: "",
        //   description: "Coversheet submission deadline",
        //   span_info: "(in days)",
        //   disabled: true,
        // },
      ],
    },
  ];

  const fetchCall = async () => {
    setAutomation((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const data = await AutomationGetCall();
      setAutomation((prev) => ({
        ...prev,
        ...data,
        loading: false,
      }));
    } catch (error) {
      setAutomation((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  useEffect(() => {
    fetchCall();
  }, []);

  const handleEditDetails = () => {
    setButton((prev) => ({
      ...prev,
      condition: false,
    }));
  };

  const handleCancel = () => {
    setButton((prev) => ({
      ...prev,
      disabled: true,
      cancelLoading: true,
    }));
    setTimeout(() => {
      setButton((prev) => ({
        ...prev,
        disabled: false,
        cancelLoading: false,
        condition: true,
      }));
      fetchCall();
    }, 1000);
  };

  const handleDeleteEmail = (index, values, setFieldValue) => {
    const filterData = values["share_emails"].filter((_, i) => i !== index);
    setFieldValue("share_emails", filterData);
  };

  const handleAddEmail = (values, setFieldValue) => {
    const newEmails = [...values.share_emails, { email: "", type: "" }];
    setFieldValue("share_emails", newEmails);
  };

  const CustomMenuItem = (item, index) => {
    return (
      <MenuItem value={item.value} key={index}>
        {item?.name}
      </MenuItem>
    );
  };

  const handleSubmit = async (values) => {
    setButton((prev) => ({
      ...prev,
      disabled: true,
      saveLoading: true,
    }));
    try {
      const data = await AutomationUpdate(values);
      await fetchCall();
      setButton((prev) => ({
        ...prev,
        disabled: false,
        saveLoading: false,
        condition: true,
      }));
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };
  return (
    <CustomDiv padding="1.5rem">
      <Formik
        enableReinitialize
        initialValues={automation}
        validationSchema={validationSchema}
        onSubmit={async (values, actions) => {
          handleSubmit(values, actions);
        }}
      >
        {({ values, errors, validateForm, touched, setFieldValue }) => {
          return (
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
            >
              <CommonGrid2 container spacing={2} flexDirection={"column"}>
                <CommonGrid2
                  display={"flex"}
                  gap={"10px"}
                  alignItems={"center"}
                >
                  <Typography variant="body5">
                    Payload should be retrieved from
                  </Typography>
                  <CandidateFitIco />
                </CommonGrid2>

                <CommonGrid2 container>
                  <CommonGrid2
                    size={6}
                    gap={"10px"}
                    display={"flex"}
                    flexDirection={"column"}
                  >
                    <Typography variant="p" color="#344054" fontSize="15px">
                      {"Email Address"}
                    </Typography>
                    {automation.loading ? (
                      <HandleSkeletion height={40} transform="scale(1)" />
                    ) : (
                      <CommonTextField
                        value={"automation@talairo.com"}
                        disabled
                        placeholder={"Enter Eamil"}
                        padding="10px"
                      />
                    )}
                  </CommonGrid2>
                </CommonGrid2>
                <CommonGrid2
                  display={"flex"}
                  flexWrap={"wrap"}
                  justifyContent={"space-between"}
                >
                  <CommonGrid2
                    display={"flex"}
                    gap={"10px"}
                    alignItems={"center"}
                  >
                    <Typography variant="body5">Stage Time Settings</Typography>
                    <CandidateFitIco />
                  </CommonGrid2>
                  {/* {automation.loading ? (
                    <HandleSkeletion
                      height={40}
                      width={100}
                      transform="scale(1)"
                    />
                  ) : (
                    <CommonButton
                      value={"Set to Default"}
                      padding={"10px 1rem"}
                      variant="outlined"
                      disabled
                      color={"#344054"}
                      border={"#D0D5DD"}
                      fontWeight={"600"}
                    />
                  )} */}
                </CommonGrid2>
                <CommonGrid2 container spacing={3} size={12}>
                  {stageTimeSetting.map(({ title, data }, index) => (
                    <CommonGrid2 key={index} size={12}>
                      <Typography variant="body4" fontWeight={700}>
                        {title}
                      </Typography>
                      <CommonGrid2
                        container
                        spacing={3}
                        size={12}
                        marginTop={"10px"}
                      >
                        {data.map((item) => {
                          return (
                            <CommonGrid2
                              item
                              size={{ sm: 6, md: 4, lg: 2, xs: 12 }}
                              flexDirection={"column"}
                              display={"flex"}
                              gap="4px"
                              // justifyContent={"space-between"}
                            >
                              <CommonGrid2
                                display={"flex"}
                                flexDirection={"column"}
                                gap={"5px"}
                              >
                                <Typography variant="body2" fontWeight={700}>
                                  {item.name}
                                </Typography>
                                <Typography variant="body8">
                                  {item.description}
                                </Typography>
                              </CommonGrid2>
                              {automation.loading ? (
                                <HandleSkeletion
                                  height={40}
                                  transform="scale(1)"
                                  width={"100%"}
                                />
                              ) : (
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <StageTimeSetting
                                    placeholder="hh:mm"
                                    format="HH:mm"
                                    values={
                                      values?.[item.objectName]?.[
                                        item.titleName
                                      ]
                                    }
                                    value={
                                      values?.[item.objectName]?.[
                                        item.titleName
                                      ]
                                        ? dayjs(
                                            values[item.objectName][
                                              item.titleName
                                            ],
                                            "HH:mm"
                                          )
                                        : null
                                    }
                                    disabled={button.condition}
                                    onChange={(newValue) => {
                                      if (newValue && newValue.isValid()) {
                                        setFieldValue(
                                          `${item.objectName}.${item.titleName}`,
                                          newValue.format("HH:mm")
                                        );
                                      } else {
                                        setFieldValue(
                                          `${item.objectName}.${item.titleName}`,
                                          ""
                                        );
                                      }
                                    }}
                                    slotProps={{
                                      textField: {
                                        error: Boolean(
                                          touched?.[item.objectName]?.[
                                            item.titleName
                                          ] &&
                                            errors?.[item.objectName]?.[
                                              item.titleName
                                            ]
                                        ),
                                        helperText:
                                          touched?.[item.objectName]?.[
                                            item.titleName
                                          ] &&
                                          errors?.[item.objectName]?.[
                                            item.titleName
                                          ],
                                        InputProps: {
                                          endAdornment: <AccessTimeIcon />,
                                        },
                                        sx: {
                                          "& .MuiFormHelperText-root.Mui-error":
                                            {
                                              fontWeight: 600,
                                              margin: "3px 0px",
                                            },
                                        },
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                              )}
                            </CommonGrid2>
                          );
                        })}
                      </CommonGrid2>
                    </CommonGrid2>
                  ))}
                </CommonGrid2>

                <CommonGrid2 container spacing={3} marginTop={"2rem"} size={12}>
                  {otherSetting.map(({ title, data }, index) => (
                    <CommonGrid2 key={index} size={12}>
                      <Typography variant="body5">{title}</Typography>
                      <CommonGrid2
                        container
                        spacing={3}
                        size={12}
                        marginTop={"1rem"}
                      >
                        {data.map((item) => {
                          return (
                            <CommonGrid2
                              item
                              size={{ sm: 6, md: 3, lg: 3, xs: 12 }}
                              flexDirection={"column"}
                              display={"flex"}
                              gap="10px"
                              justifyContent={
                                Boolean(
                                  touched?.[item.titleName] &&
                                    errors?.[item.titleName]
                                )
                                  ? "flex-start"
                                  : "space-between"
                              }
                            >
                              <CommonGrid2
                                display={"flex"}
                                flexDirection={"column"}
                                gap={"2px"}
                              >
                                <Typography variant="body2" fontWeight={700}>
                                  {item.name}
                                </Typography>
                                <Typography variant="body8">
                                  {item.description}{" "}
                                  <CustomizeSpan color="#8396A8">
                                    {item.span_info}
                                  </CustomizeSpan>
                                </Typography>
                              </CommonGrid2>
                              {automation.loading ? (
                                <HandleSkeletion
                                  height={40}
                                  transform="scale(1)"
                                  width={"100%"}
                                />
                              ) : (
                                <CommonTextField
                                  value={values[item.titleName]}
                                  disabled={item.disabled || button.condition}
                                  error={Boolean(
                                    touched?.[item.titleName] &&
                                      errors?.[item.titleName]
                                  )}
                                  helperText={
                                    touched?.[item.titleName] &&
                                    errors?.[item.titleName]
                                  }
                                  padding="8px 10px"
                                  onChange={(e) => {
                                    const onlyNumbers = e.target.value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    setFieldValue(item.titleName, onlyNumbers);
                                  }}
                                />
                              )}
                            </CommonGrid2>
                          );
                        })}
                      </CommonGrid2>
                    </CommonGrid2>
                  ))}
                </CommonGrid2>
                <CommonGrid2
                  display={"flex"}
                  flexWrap={"wrap"}
                  gap={"1rem"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <CommonGrid2
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"5px"}
                    marginTop={"10px"}
                  >
                    <Typography variant="body2" fontWeight={700}>
                      Job Sharing
                    </Typography>
                    <Typography variant="body8">
                      Activated Job should be shared to
                    </Typography>
                  </CommonGrid2>
                  <CommonButton
                    value={"Add Email"}
                    startIcon={<AddIcon />}
                    variant="outlined"
                    fontWeight={600}
                    disabled={button.condition}
                    color="#344054"
                    padding={"8px 1rem"}
                    gap="0px"
                    onClick={() => handleAddEmail(values, setFieldValue)}
                    width="max-content"
                    customStyle={{
                      height: "max-content",
                    }}
                  />
                </CommonGrid2>
                <CommonGrid2 container spacing={3} marginTop={"10px"}>
                  {(automation.loading ? [1] : values.share_emails).map(
                    (item, index) => (
                      <CommonGrid2 item size={{ sm: 6, md: 6, lg: 6, xs: 12 }}>
                        {automation.loading ? (
                          <HandleSkeletion
                            height={40}
                            transform="scale(1)"
                            width={"100%"}
                          />
                        ) : (
                          <CommonGrid2 display={"flex"} gap={"10px"}>
                            <CommonTextField
                              label={"Enter Email"}
                              value={item.email}
                              padding={"11px"}
                              disabled={button.condition}
                              onChange={(e) => {
                                setFieldValue(
                                  `share_emails.${index}.email`,
                                  e.target.value
                                );
                              }}
                              error={Boolean(
                                touched?.share_emails?.[index]?.email &&
                                  errors?.share_emails?.[index]?.email
                              )}
                              helperText={
                                touched?.share_emails?.[index]?.email &&
                                errors?.share_emails?.[index]?.email
                              }
                              sizeMedium="-5px"
                            />
                            <DropDownSelect
                              marginTop="0px"
                              title={"Select Designation"}
                              removeAnimation={false}
                              handleRenderValue={(selected) => {
                                const data = statusOptions.find(
                                  (item) => item.value === selected
                                );
                                return data.name;
                              }}
                              padding={"12px"}
                              valueChange={true}
                              data={statusOptions}
                              disabled={button.condition}
                              CustomMenuItem={CustomMenuItem}
                              sizeMedium="-5px"
                              value={item.type}
                              handleChange={(e) => {
                                setFieldValue(
                                  `share_emails.${index}.type`,
                                  e.target.value
                                );
                              }}
                            />
                            <CommonButton
                              value={<DeleteIco stroke="red" />}
                              variant="outlined"
                              padding={"11px"}
                              minWidth={"max-content"}
                              svg={true}
                              disabled={button.condition}
                              customStyle={{
                                maxHeight: "fit-content",
                              }}
                              onClick={() =>
                                handleDeleteEmail(index, values, setFieldValue)
                              }
                            />
                          </CommonGrid2>
                        )}
                      </CommonGrid2>
                    )
                  )}
                </CommonGrid2>
              </CommonGrid2>
              <CommonGrid2
                justifyContent={"end"}
                display={"flex"}
                gap={"1rem"}
                marginTop={"1rem"}
              >
                {button.condition ? (
                  <CommonButton
                    value={"Edit Details"}
                    startIcon={<EditIcon />}
                    fontWeight={600}
                    padding={"8px 1rem"}
                    gap="0px"
                    width="max-content"
                    onClick={handleEditDetails}
                  />
                ) : (
                  <Fragment>
                    <CommonButton
                      variant="outlined"
                      value={"Cancel"}
                      fontWeight={600}
                      padding={"8px 1rem"}
                      width="max-content"
                      onClick={handleCancel}
                      disabled={button.disabled}
                      loading={button.cancelLoading}
                    />
                    <CommonButton
                      value={"Save"}
                      fontWeight={600}
                      padding={"8px 1.5rem"}
                      width="max-content"
                      type="submit"
                      disabled={button.disabled}
                      loading={button.saveLoading}
                    />
                  </Fragment>
                )}
              </CommonGrid2>
            </Form>
          );
        }}
      </Formik>
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
